import { postRequest, API } from 'utils/request';

const postChangePassword = async postParams => {
  const res = await postRequest(`${API.changePassword}`, postParams);
  return res;
};

export { postChangePassword };
